<template>
  <div>
    <input type="checkbox" :checked="active" />
  </div>
</template>

<script>
export default {
  name: "base-checkbox",
  model: {
    prop: "checked",
    event: "change",
  },
  props: ["checked", "value"],
  computed: {
    active() {
      return this.checked.includes(this.value);
    },
  },
};
</script>
